import { Box, Chip, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';
import { insuranceSelector } from '../model';
import { InsuranceProposals } from './InsuranceProposals';

export const CoverageStatus = () => {
  const classes = useStyles();

  const coverageStatusConfig = useSelector(insuranceSelector.coverageStatusConfig);
  const isInsuranceExpressIntegrated = useSelector(insuranceSelector.isInsuranceExpressIntegrated);
  const { icon: CoverageStatusIcon } = coverageStatusConfig;

  return (
    <Box className={classes.container}>
      <Box className={classes.root}>
        <Typography className={classes.coverageStatus}>
          Coverage Status:
          <Chip
            icon={<CoverageStatusIcon />}
            label={coverageStatusConfig.label}
            sx={{
              color: coverageStatusConfig.color,
              bgcolor: coverageStatusConfig.bgColor,
              '& .MuiChip-icon': {
                color: coverageStatusConfig.color,
              },
              ml: 1,
            }}
            size="small"
          />
        </Typography>
        {coverageStatusConfig.helperText && <Typography>{coverageStatusConfig.helperText}</Typography>}
      </Box>
      {isInsuranceExpressIntegrated && (
        <Box className={classes.root}>
          <InsuranceProposals />
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    gap: 16, // optional spacing between children
  },
  root: {
    maxWidth: '50%',
  },
  coverageStatus: {
    color: '#000000de',
    fontWeight: 500,
    marginBottom: 4,
    display: 'flex',
    alignItems: 'center',
  },
});
